import React, { useState } from 'react';
import { Header, Footer, MobileBottomNav } from '../components/Layout';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';
import { Shield, Star, CheckCircle2, Users } from 'lucide-react';

const NPC_MODERATORS = [
  { id: 1, name: "Alex Modsworth", games: 342, rating: 4.9, online: true, avatar: "AM" },
  { id: 2, name: "Sarah Referee", games: 289, rating: 4.8, online: true, avatar: "SR" },
  { id: 3, name: "Mike Fairplay", games: 267, rating: 4.7, online: true, avatar: "MF" },
  { id: 4, name: "Lisa Judge", games: 234, rating: 4.9, online: true, avatar: "LJ" },
  { id: 5, name: "David Rules", games: 198, rating: 4.6, online: true, avatar: "DR" },
  { id: 6, name: "Emma Arbiter", games: 176, rating: 4.8, online: true, avatar: "EA" },
  { id: 7, name: "James Verdict", games: 156, rating: 4.5, online: false, avatar: "JV" },
  { id: 8, name: "Nina Justice", games: 145, rating: 4.7, online: true, avatar: "NJ" },
  { id: 9, name: "Carlos Decider", games: 132, rating: 4.6, online: true, avatar: "CD" },
  { id: 10, name: "Zara Watchdog", games: 121, rating: 4.4, online: false, avatar: "ZW" },
];

const ModeratorsPage = () => {
  const [selectedMod, setSelectedMod] = useState(null);

  return (
    <div className="min-h-screen bg-[#1A1A1A] flex flex-col pb-20 md:pb-0 overflow-x-hidden">
      <Header />
      <main className="flex-1 max-w-4xl mx-auto px-4 py-8 w-full">
        <div className="flex items-center gap-3 mb-8">
          <Shield className="h-8 w-8 text-[#D4AF37]" />
          <div>
            <h1 className="text-3xl font-black uppercase text-white" style={{ fontFamily: 'Outfit' }}>
              Available <span className="text-[#D4AF37]">Moderators</span>
            </h1>
            <p className="text-gray-400">Select a moderator for your high-stakes games</p>
          </div>
        </div>

        <div className="space-y-3">
          {NPC_MODERATORS.map((mod) => (
            <div
              key={mod.id}
              className={`card-dark flex items-center gap-4 transition-all cursor-pointer ${
                selectedMod === mod.id ? 'border-[#D4AF37] ring-1 ring-[#D4AF37]' : ''
              }`}
              onClick={() => setSelectedMod(mod.id)}
              data-testid={`moderator-${mod.id}`}
            >
              <div className="relative flex-shrink-0">
                <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#D4AF37] to-[#28A745] flex items-center justify-center text-[#1A1A1A] font-bold text-lg">
                  {mod.avatar}
                </div>
                <div className={`absolute -bottom-0.5 -right-0.5 w-4 h-4 rounded-full border-2 border-[#1A1A1A] ${mod.online ? 'bg-[#28A745]' : 'bg-gray-500'}`} />
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="font-bold text-white">{mod.name}</span>
                  <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${mod.online ? 'bg-[#28A745]/20 text-[#28A745]' : 'bg-gray-500/20 text-gray-400'}`}>
                    {mod.online ? 'Online' : 'Offline'}
                  </span>
                </div>
                <div className="flex items-center gap-4 mt-1 text-sm text-gray-400">
                  <span className="flex items-center gap-1">
                    <Users className="h-3 w-3" /> {mod.games} games
                  </span>
                  <span className="flex items-center gap-1">
                    <Star className="h-3 w-3 text-[#D4AF37]" /> {mod.rating}
                  </span>
                </div>
              </div>

              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  if (!mod.online) {
                    toast.error(`${mod.name} is currently offline`);
                    return;
                  }
                  setSelectedMod(mod.id);
                  toast.success(`${mod.name} selected as moderator!`);
                }}
                className={mod.online ? 'btn-primary text-sm' : 'bg-[#2D2D2D] text-gray-500 text-sm'}
                disabled={!mod.online}
                data-testid={`select-mod-${mod.id}`}
              >
                {selectedMod === mod.id ? <><CheckCircle2 className="h-4 w-4 mr-1" /> Selected</> : 'Select'}
              </Button>
            </div>
          ))}
        </div>
      </main>
      <Footer />
      <MobileBottomNav />
    </div>
  );
};

export default ModeratorsPage;
